export default __webpack_public_path__ + "assets/NotoSans-SemiBold.a75c33f6.ttf";